import React from 'react';
import { useRoutes } from 'react-router-dom';
import routes from './config/routes';

const App: React.FC = () => {
  const routing = useRoutes(routes);

  return (
    <div>
      {routing}
      
    </div>
  );
};

export default App;